export const SAPS2_SCORE = {
  masterTableName: "MC_SAPSII",
  tableName: "MC_SAPSII_DET",
  columnName: "S_ID",
  columnValue: 0,
  title: "saps2-score.title",
  rows: [
    { title: "id", value: "ID" },
    { title: "date", value: "PROCESS_TIME", headerName: "datetime", type: "date" },
    { title: "age", value: "AGE_XNAME" },
    { title: "lyingposition", value: "TYPE_OF_HOSPITALIZATION_XNAME" },
    { title: "chronicdisease", value: "CHRONIC_DISEASE_XNAME" },
    { title: "heartrate", value: "HEART_RATE_XNAME" },
    { title: "bodytemp", value: "BODY_TEMP_XNAME" },
    { title: "serorureorbum", value: "SERUM_XNAME" },
    { title: "sodium", value: "SODIUM_XNAME" },
    { title: "systolicbloodpressure", value: "SYSTOLIC_BLOOD_PRESSURE_XNAME" },
    { title: "PaOFIO2", value: "PAO2_FIO2_XNAME" },
    { title: "WBC", value: "WBC_XNAME" },
    { title: "HCO3", value: "HCO3_XNAME" },
    { title: "potasium", value: "POTASSIUM_XNAME" },
    { title: "bilirubin", value: "BILIRUBIN_XNAME" },
    { title: "urineOutput", value: "URINE_OUTPUT_XNAME" },
    { title: "scoreRange", value: "GLASGOW_SCORE_SELECT_XNAME" },
    { title: "sapsIIScore", value: "SAPSII_SCORE" },
    { title: "se_age", value: "SE_AGE_XNAME" },
    { title: "gender", value: "GENDER_XNAME" },
    { title: "beforeIntensiveCare", value: "PREVIOUS_LOCATION_XNAME" },
    { title: "beforeInsentiveCareWaitTime", value: "DURATION_OF_STAY_XNAME" },
    { title: "clinicalCategory", value: "CLINICAL_CATEGORY_XNAME" },
    { title: "poisoning", value: "POISONING_XNAME" },
    { title: "sapsIIExtendedScore", value: "SAPSII_EXTENDED_SCORE" },
    { title: "expectedMortality", value: "EXPECTED_MORTALITY" },
  ],
  fields: [
    { field: "date", headerName: "datetime", flex: 1 },
    { field: "age", headerName: "saps2-score.age", flex: 1 },
    { field: "lyingposition", headerName: "saps2-score.lyingposition", flex: 1 },
    { field: "chronicdisease", headerName: "saps2-score.chronicdisease", flex: 1 },
    { field: "heartrate", headerName: "saps2-score.heartrate", flex: 1 },
    { field: "bodytemp", headerName: "saps2-score.bodytemp", flex: 1 },
    { field: "serorureorbum", headerName: "saps2-score.serorureorbum", flex: 1 },
    { field: "sodium", headerName: "saps2-score.sodium", flex: 1 },
    { field: "systolicbloodpressure", headerName: "saps2-score.systolicbloodpressure", flex: 1 },
    { field: "PaOFIO2", headerName: "saps2-score.PaOFIO2", flex: 1 },
    { field: "WBC", headerName: "saps2-score.WBC", flex: 1 },
    { field: "HCO3", headerName: "saps2-score.HCO3", flex: 1 },
    { field: "potasium", headerName: "saps2-score.potasium", flex: 1 },
    { field: "bilirubin", headerName: "saps2-score.bilirubin", flex: 1 },
    { field: "urineOutput", headerName: "saps2-score.urineOutput", flex: 1 },
    { field: "scoreRange", headerName: "saps2-score.scoreRange", flex: 1 },
    {
      field: "sapsIIScore",
      headerName: "saps2-score.sapsIIScore",
      flex: 1,
      computed: true,
      calculate: (row: any) => {
        const age = Number(row.AGE_XVALUE) || 0;
        const lyingposition = Number(row.TYPE_OF_HOSPITALIZATION_XVALUE) || 0;
        const chronicdisease = Number(row.CHRONIC_DISEASE_XVALUE) || 0;
        const heartrate = Number(row.HEART_RATE_XVALUE) || 0;
        const bodytemp = Number(row.BODY_TEMP_XVALUE) || 0;
        const serum = Number(row.SERUM_XVALUE) || 0;
        const sodium = Number(row.SODIUM_XVALUE) || 0;
        const systolicbloodpressure = Number(row.SYSTOLIC_BLOOD_PRESSURE_XVALUE) || 0;
        const pao2fio2 = Number(row.PAO2_FIO2_XVALUE) || 0;
        const wbc = Number(row.WBC_XVALUE) || 0;
        const hco3 = Number(row.HCO3_XVALUE) || 0;
        const potassium = Number(row.POTASSIUM_XVALUE) || 0;
        const bilirubin = Number(row.BILIRUBIN_XVALUE) || 0;
        const urineOutput = Number(row.URINE_OUTPUT_XVALUE) || 0;
        const glasgow = Number(row.GLASGOW_SCORE_SELECT_XVALUE) || 0;

        return age + lyingposition + chronicdisease + heartrate + bodytemp + serum + sodium + systolicbloodpressure + pao2fio2 + wbc + hco3 + potassium + bilirubin + urineOutput + glasgow;
      }
    },
    { field: "se_age", headerName: "saps2-score.age", flex: 1 },
    { field: "gender", headerName: "saps2-score.gender", flex: 1 },
    { field: "beforeIntensiveCare", headerName: "saps2-score.beforeIntensiveCare", flex: 1 },
    { field: "beforeInsentiveCareWaitTime", headerName: "saps2-score.beforeInsentiveCareWaitTime", flex: 1 },
    { field: "clinicalCategory", headerName: "saps2-score.clinicalCategory", flex: 1 },
    { field: "poisoning", headerName: "saps2-score.poisoning", flex: 1 },
    { field: "sapsIIExtendedScore", headerName: "saps2-score.sapsIIExtendedScore", flex: 1 },
    { field: "expectedMortality", headerName: "saps2-score.expectedMortality", flex: 1 },
  ],
  mcpConfig: {
    AGE: { mcpId: 530, field: "AGE", scoreField: "AGE_XVALUE" },
    TYPE_OF_HOSPITALIZATION: { mcpId: 531, field: "TYPE_OF_HOSPITALIZATION", scoreField: "TYPE_OF_HOSPITALIZATION_XVALUE" },
    CHRONIC_DISEASE: { mcpId: 532, field: "CHRONIC_DISEASE", scoreField: "CHRONIC_DISEASE_XVALUE" },
    HEART_RATE: { mcpId: 533, field: "HEART_RATE", scoreField: "HEART_RATE_XVALUE" },
    BODY_TEMP: { mcpId: 534, field: "BODY_TEMP", scoreField: "BODY_TEMP_XVALUE" },
    SERUM: { mcpId: 535, field: "SERUM", scoreField: "SERUM_XVALUE" },
    SODIUM: { mcpId: 536, field: "SODIUM", scoreField: "SODIUM_XVALUE" },
    SYSTOLIC_BLOOD_PRESSURE: { mcpId: 537, field: "SYSTOLIC_BLOOD_PRESSURE", scoreField: "SYSTOLIC_BLOOD_PRESSURE_XVALUE" },
    PAO2_FIO2: { mcpId: 538, field: "PAO2_FIO2", scoreField: "PAO2_FIO2_XVALUE" },
    WBC: { mcpId: 539, field: "WBC", scoreField: "WBC_XVALUE" },
    HCO3: { mcpId: 540, field: "HCO3", scoreField: "HCO3_XVALUE" },
    POTASSIUM: { mcpId: 541, field: "POTASSIUM", scoreField: "POTASSIUM_XVALUE" },
    BILIRUBIN: { mcpId: 542, field: "BILIRUBIN", scoreField: "BILIRUBIN_XVALUE" },
    URINE_OUTPUT: { mcpId: 543, field: "URINE_OUTPUT", scoreField: "URINE_OUTPUT_XVALUE" },
    GLASGOW_SCORE_SELECT: { mcpId: 544, field: "GLASGOW_SCORE_SELECT", scoreField: "GLASGOW_SCORE_SELECT_XVALUE" },
    SE_AGE: { mcpId: 545, field: "SE_AGE", scoreField: "SE_AGE_XVALUE" },
    GENDER: { mcpId: 546, field: "GENDER", scoreField: "GENDER_XVALUE" },
    PREVIOUS_LOCATION: { mcpId: 547, field: "PREVIOUS_LOCATION", scoreField: "PREVIOUS_LOCATION_XVALUE" },
    DURATION_OF_STAY: { mcpId: 548, field: "DURATION_OF_STAY", scoreField: "DURATION_OF_STAY_XVALUE" },
    CLINICAL_CATEGORY: { mcpId: 549, field: "CLINICAL_CATEGORY", scoreField: "CLINICAL_CATEGORY_XVALUE" },
    POISONING: { mcpId: 550, field: "POISONING", scoreField: "POISONING_XVALUE" },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    S_ID: "",
    PROCESS_TIME: new Date(),
    CTIME: new Date(),
    CUSER: "",
    BODY_TEMP: "",
    SYSTOLIC_BLOOD_PRESSURE: "",
    HEART_RATE: "",
    PAO2_FIO2: "",
    HCO3: "",
    WBC: "",
    SERUM: "",
    GLASGOW_SCORE: "",
    AGE: "",
    CHRONIC_DISEASE: "",
    SAPSII_SCORE: 0,
    EXPECTED_MORTALITY: 0,
    GLASGOW_SCORE_SELECT: "",
    TYPE_OF_HOSPITALIZATION: "",
    SODIUM: "",
    POTASSIUM: "",
    BILIRUBIN: "",
    URINE_OUTPUT: "",
    SE_AGE: "",
    GENDER: "",
    PREVIOUS_LOCATION: "",
    DURATION_OF_STAY: "",
    CLINICAL_CATEGORY: "",
    POISONING: "",
    SAPSII_EXTENDED_SCORE: 0,
    SERUM_LAB: "",
    SODIUM_LAB: "",
    WBC_LAB: "",
    HCO3_LAB: "",
    POTASSIUM_LAB: "",
    BILIRUBIN_LAB: "",
    MICRDS_ID: "",
  },
  chartScoreField: "SAPSII_SCORE",
  chartTimeField: "PROCESS_TIME",
};
